import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss']
})
export class VideosComponent implements OnInit {
  videos: { title: string, url: SafeResourceUrl }[] = [
    { title: '#Huellas | Vecinos buscan crear el primer barrio sustentable de Rosario', url: this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/K1vnUiTHIQA') },
    { title: '#Huellas | La Higuera, 20 años de trabajo en salud y desarrollo de comunidades rurales', url: this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/dxyOkIdYXr0') },
    { title: '#Huellas | Matricia: innovación social y superación con mujeres como protagonistas', url: this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/qCd6Eem_Zhw') },
    { title: '#Huellas | Recetas contra la inflación: pastelería sin gluten de Villa Banana que busca concientizar', url: this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/6gQRzXJFSnQ') }
  ];

  highlightedVideo = this.videos[this.videos.length - 1]; // Seleccionamos el último video como destacado

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
  }

}
